// @ vendors
import React from 'react';
// @ utilities
import { recordedInitialPage } from 'utilities/uTagging';
const { JointLogin } = require('components/jointHolders/JointLogin');

class ClientLogin extends React.Component {
    state = {
        showLoginForm: true,
    };

    componentDidMount() {
        recordedInitialPage();
    }

    handleClickShowLogin = () => {
        this.setState({ showLoginForm: !this.state.showLoginForm });
    };

    render() {
        return <JointLogin show={this.state.showLoginForm} onClose={this.handleClickShowLogin} />;
    }
}

module.exports = ClientLogin;
